import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import OverviewGraph from './OverviewGraph'

const FileCountGrowthGraph = ({
  title,
  analyticStatData,
  setUser,
  user,
}: {
  title: string
  analyticStatData: any
  setUser: any
  user: any
}) => {
  const { formatMessage } = useIntl()
  const seriesPriceData = [
    {
      name: 'File Count',
      data: analyticStatData?.finalMonthlyCounts?.map((item: any) => item.fileCount) || [],
    },
  ]

  const categoriesValidationData =
    analyticStatData?.finalMonthlyCounts?.map((item: any) => {
      const dateString = item.month
      const date = new Date(dateString)

      const formattedDate = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
      })
      return formattedDate
    }) || []

  const dropdownForUsers = [
    { name: 'All Users', value: 'undefined' },
    ...(Array.isArray(analyticStatData?.uniqueUsers)
      ? analyticStatData.uniqueUsers.map((item: any) => ({
        name: `${item.firstName} ${item.lastName}`,
        value: item.userId,
      }))
      : []),
  ]

  return (
    <Card className='w-100 p-4 bg-white'>
      <div className='d-flex flex-column justify-content-between align-items-center'>
        <div className='d-flex flex-md-row flex-column justify-content-md-between align-items-md-center align-items-start w-100 px-4'>
          <p className='text-muted mb-2 mb-md-0'>{formatMessage({ id: title })}</p>
          <div className='dropdown-center w-md-auto w-100'>
            <select
              className='form-select h-40px font-size-12 font-weight-500 bg-white cursor-pointer'
              onChange={(e) => {
                setUser(e.target.value)
              }}
              value={user}
            >
              {dropdownForUsers?.map((item: any) => {
                return <option value={item?.value}>{item?.name}</option>
              })}
            </select>
          </div>
        </div>
      </div>
      <OverviewGraph series={seriesPriceData} categories={categoriesValidationData} />
    </Card>
  )
}

export default FileCountGrowthGraph